import api from "api";
import produce from "immer";
import { useMutation, useQueryClient } from "react-query";
import { Row } from "shared/ValueTable/ValueTable";
import { join } from "utils/misc";
import useRegistry from "../useRegistry";

const useUpdateRecord = <R extends Row>(overrideRegistry?: string) => {
  const registry = useRegistry(overrideRegistry);
  const queryClient = useQueryClient();
  const mutation = useMutation(({ value, ...data }: R) =>
    api.call(join(registry.api, value), { data, method: "PATCH" })
  );

  const updateRecord = async (record: R) => {
    const key = registry.name;
    const old = queryClient.getQueryData<Row[]>(key)!;
    queryClient.cancelQueries(key);
    queryClient.setQueryData(
      key,
      produce(old, draft => {
        const index = old.indexOf(old.find(({ value }) => value === record.value)!);
        draft.splice(index, 1, record);
      })
    );

    try {
      await mutation.mutateAsync(record);
      queryClient.invalidateQueries(key);
    } catch (err) {
      queryClient.setQueryData(key, old);
      throw err;
    }
  };

  return { ...mutation, updateRecord };
};

export default useUpdateRecord;
